module.exports = __webpack_public_path__ + "img/de-product-classify_img_8.5dcf358c.jpg";